import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import styles from './ConfirmDialog.module.css'

const MODAL_OPEN_CLASS = 'app-modal-open'

export interface ConfirmDialogProps {
  open: boolean
  title: string
  message?: string
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  useEffect(() => {
    if (!open) return
    document.documentElement.classList.add(MODAL_OPEN_CLASS)
    return () => {
      document.documentElement.classList.remove(MODAL_OPEN_CLASS)
    }
  }, [open])

  if (!open) return null

  return createPortal(
    <div className={styles.backdrop} role="presentation" onClick={loading ? undefined : onCancel}>
      <div
        className={styles.dialog}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        aria-describedby={message ? 'confirm-desc' : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="confirm-title" className={styles.title}>
          {title}
        </h2>
        {message && (
          <p id="confirm-desc" className={styles.message}>
            {message}
          </p>
        )}
        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? styles.dangerBtn : styles.confirmBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'A processar…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
